export default __webpack_public_path__ + "static/media/aws.667be7ef.svg";